<template>
  <section class="table-wrap">
    <header>
      <h4>Resultado da Busca</h4>
      <p v-if="turmas">{{ turmas.length }} {{ turmas.length == 1 ? 'item encontrado' : 'itens encontrados' }} </p>
    </header>
    <div v-if="turmas && turmas.length === 0" class="empty-state" role="status">
      Nenhuma turma encontrada para os filtros informados.
    </div>
    <div v-else-if="turmas" class="table-scroll">
    <table class="transparent-table">
      <thead>
        <tr>
          <th>ID Turma</th>
          <th>TURCódigo</th>
          <th>Descrição</th>
          <th>Detalhes</th>
          <th>Série</th>
          <th>Capacidade</th>
          <th>Vagas</th>
          <th>Inscritos</th>
          <th>Local</th>
          <th>Ativo</th>
          <th>Alertas</th>
          <th>Sincronização</th>
          <th class="text-right">
            <label class="check-control">
              <span>Selecionar Todos</span>
              <input
                type="checkbox"
                class="check"
                v-model="all"
                @change="toggleAll()"
                :disabled="!canManage || isSaving"
                aria-label="Selecionar todas as turmas"
              >
            </label>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(turma,i) in turmas" :key="turma.idTurma" :class="{ 'row-error': turma.syncError }">
          <td>
            {{ turma.idTurma }}
          </td>
          <td>
            {{ turma.TURCodigo }}
          </td>
          <td>
            {{ turma.descricao ? turma.descricao : '-' }}
          </td>
          <td>
            <input-control v-model="turma.detalhes" :disabled="!editTurma" cssClass="small invert" @change="toggleChange(i)"></input-control>
          </td>
          <td>
            {{ turma.descricaoSerie }}
          </td>
          <td>
            <input-control v-model="turma.capacidade" :disabled="!editTurma" cssClass="small invert table-input" @change="toggleChange(i)"></input-control>
          </td>
          <td>
            {{ turma.vagas }}
            <!-- <input-control v-model="turma.vagas" cssClass="small invert table-input"></input-control> -->
          </td>
          <td>
            {{ turma.inscritos }}
            <!-- <input-control v-model="turma.inscritos" cssClass="small invert table-input"></input-control> -->
          </td>
          <td>
            <select-control cssClass="small" placeholder="Selecione" :options="turma.locais" v-model="turma.idLocal" :disabled="turma.locais.length == 0 || !(editTurma || editLocalTurma)" v-if="turma.locais" @change="toggleChange(i)"/>
            <mini-spinner v-else />
          </td>
          <td class="form-group">
            <div class="switchWrapMiniLoose">
              <switch-control v-model:checked="turma.ativo" @change="toggleChange(i)" :disabled="!editTurma" invert></switch-control>
            </div>
          </td>
          <td>
            <fa :icon="['fas','triangle-exclamation']" class="icon color-alert" v-if="!turma.TURCodigo" title="Turma não integrada no GestorClass"></fa>
            <fa :icon="['fas','school-circle-exclamation']" class="icon color-alert"   v-if="getCapacidadePedagogica(turma) !== null && parseInt(turma.capacidade) > parseInt(getCapacidadePedagogica(turma))"    title="Sala não suporta a quantidade de alunos inscritos"></fa>
          </td>
          <td class="sync-status" aria-live="polite">
            <small v-if="turma.syncError" class="sync-error" role="alert">
              Falha: {{ turma.syncError }}
            </small>
            <small v-else-if="turma.TURCodigo" class="sync-success">Sincronizada</small>
            <small v-else class="sync-pending">Pendente</small>
          </td>
          <!-- <td>
            <a href="#" @click.prevent="selectTurma(turma)">
              <fa :icon="['fas','magnifying-glass']" class="icon"></fa>
            </a>
          </td> -->
          <td class="text-right">
            <label class="check-control">
              <input
                type="checkbox"
                class="check"
                v-model="turma.selected"
                @change="toggleSelect()"
                :disabled="!canManage || isSaving"
                :aria-label="`Selecionar turma ${turma.descricao || turma.idTurma}`"
              >
            </label>
          </td>
        </tr>
      </tbody>
    </table>
    </div>
    <footer class="action-wrap">
      <!-- <label class="check-control">
        <input type="checkbox" class="check" v-model="syncOut">
        <span>
          Sincronizar com Perseus
        </span>
      </label> -->
      <span class="selection-summary" aria-live="polite">
        {{ selectedCount }} {{ selectedCount === 1 ? 'turma selecionada' : 'turmas selecionadas' }}
      </span>
      <button
        type="button"
        class="btn btn-primary"
        @click="confirmSync()"
        :disabled="!canManage || selectedCount === 0 || isSaving"
      >
        {{ isSaving ? 'Salvando...' : 'Salvar e sincronizar' }}
      </button>
    </footer>
    <confirm 
      :backdrop="false"
      class="confirm"
      ref="confirm"
    ></confirm>
  </section>
</template>

<script>

import AcademicoService from  '@/services/academico.service.js'
import MiniSpinner from '@/components/utilities/MiniSpinner.vue'
import UserService from '@/services/user.service.js'
import { createSelectOptions } from '@/services/utils.service.js'

export default {
  props: {
    scope: {
      type: Array
    }
  },
  components: {
    MiniSpinner
  },
  watch: {
    scope ( value ) {
      if ( value ) {
        this.turmas = this.prepareTurmas(value)
        this.addSelector(true)
        this.set()
      }
    }
  },
  computed: {
    selectedCount () {
      return this.turmas ? this.turmas.filter(turma => turma.selected).length : 0
    },
    canManage () {
      return this.editTurma || this.editLocalTurma
    }
  },
  data () {
    return {
      turmas: null,
      all: false,
      editTurma: false,
      editLocalTurma: false,
      isSaving: false
    }
  },
  mounted () {
    this.editTurma = UserService.filterPermissions('editTurma')
    this.editLocalTurma = UserService.filterPermissions('editLocalTurma')
    this.turmas = this.prepareTurmas(this.scope)
    this.set()
    this.addSelector(true)
  },
  methods: {
    prepareTurmas ( turmas ) {
      return (turmas || []).map(turma => ({
        ...turma,
        selected: false,
        syncError: null
      }))
    },
    getCapacidadePedagogica ( turma ) {
      const local = turma.locais?.find(l => String(l.value) === String(turma.idLocal))
      return local?.capacidadePedagogica ?? null
    },
    set () {
      // console.log("turmas:")
      this.turmas.map( (k, i) => {
        this.getLocais(i)
      })
    },
    getLocais ( i ) {
      const { idCurso, idUnidade } = this.turmas[i]

      AcademicoService.getLocaisByCurso( idCurso, idUnidade ).then(
        response => {
          const locais = response.data.map(k => {
            return{
              ...k, 
              tag: ` ${k.descricao} (${k.capacidade})`
            }
          })
          this.turmas[i].locais = response.data.length > 0 ? createSelectOptions(locais, 'idLocal', 'tag') : []
        },
        () => {
          this.turmas[i].locais = []
        }
      )
    },  
    toggleAll () {
      this.addSelector(!this.all)
    },
    toggleSelect () {
      this.all = this.turmas.length > 0 && this.turmas.every(turma => turma.selected)
    },
    toggleChange ( index ) {
      this.turmas[index].selected = true
      this.turmas[index].syncError = null
      this.toggleSelect()
    },  
    addSelector ( off ) {
      this.turmas.map( k => {
        k.selected = off ? false : true
      })
      this.all = !off && this.turmas.length > 0
    },  
    confirmSync () {
      if ( this.selectedCount === 0 || this.isSaving ) {
        return
      }

      this.$refs.confirm.run({
        message: `Deseja salvar no Apollo e sincronizar ${this.selectedCount} ${this.selectedCount === 1 ? 'turma' : 'turmas'} com o Perseus?`,
        confirmButton: "Sim",
        denyButton: "Não",
        // data: gatilho,
        callback: this.sync,
      })
    },
    sync ( response ) {
      if ( response ) {
        const drop = this.turmas.filter(turma => turma.selected)
        this.isSaving = true
        window.spinner.emit("open")
        AcademicoService.saveTurmas( drop, 1 ).then(
          response => {
            this.applySyncResults(response.data.results || [])

            if ( response.data.success ) {
              window.toaster.emit('open', {style: "success", message: response.data.message || "Turmas salvas e sincronizadas com sucesso.", floater: true})
              this.$emit('onSave')
            } else {
              window.toaster.emit('open', {style: "error", message: response.data.message || "Algumas turmas não foram sincronizadas.", floater: true})
            }
          },
          error => {
            const responseData = error.response?.data || {}
            this.applySyncResults(responseData.results || [])
            window.toaster.emit('open', {style: "error", message: responseData.message || "Não foi possível salvar e sincronizar as turmas selecionadas.", floater: true})
          }
        ).finally(() => {
          this.isSaving = false
          window.spinner.emit("close")
        })
      }
    },
    applySyncResults ( results ) {
      results.forEach(result => {
        const turma = this.turmas.find(item => item.idTurma === result.idTurma)
        if ( turma ) {
          turma.syncError = result.success ? null : result.message
          turma.selected = !result.success
          if ( result.success && result.perseus?.data?.turCodigo ) {
            turma.TURCodigo = result.perseus.data.turCodigo
          }
        }
      })
      this.toggleSelect()
    },
    selectTurma( turma ) {
      this.$emit('onSelect', turma)
    }
  }
}
</script>

<style lang="scss" scoped>
  .table-wrap {
    padding: $hmg $hmg_small $mg_extra;
  }

  .table-scroll {
    overflow-x: auto;
  }

  .empty-state {
    margin: $hmg $hmg_small;
    padding: $hmg;
    border: 1px solid $color-component;
    border-radius: $border-radius;
    color: $color-text;
  }

  .row-error {
    background: rgba($color-alert, .08);
  }

  .sync-error {
    display: block;
    min-width: 220px;
    max-width: 300px;
    color: $color-error;
    text-align: left;
    white-space: normal;
  }

  .sync-status {
    vertical-align: middle;
  }

  .sync-success {
    color: $color-finalizado;
  }

  .sync-pending {
    color: $color-pendente;
  }
  
  .action-wrap {
    display: flex; align-content: center; align-items: center;
    justify-content: flex-end;
    padding: $hmg $hmg_small;

    button {
      margin-left: $hmg_small
    }

    label{
      margin-right: $hmg
    }
  }

  .selection-summary {
    color: $color-text;
  }
</style>
